export enum DeliveriesListActions {
  CREATE_DELIVERY = 'CREATE_DELIVERY'
}
